import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	quote: {
		id: 'schools.quote',
		defaultMessage:
			'“If every 8 year old is taught meditation, we will eliminate violence from the world within one generation.”',
		description: 'Calm Schools quote text',
	},
	quoteCitation: {
		id: 'schools.quoteCitation',
		defaultMessage: '— Dalai Lama',
		description: 'Calm Schools quote text',
	},
});
